<template>
  <!--====== Section 7: CTA ======-->
  <div class="ai-studio-cta-area">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="text-center">
            <h3 class="cta-title">AI로 만드는 외주,<br>한 번 경험해보세요.</h3>
            <p class="cta-desc">프로젝트 상담부터 견적까지, 부담 없이 문의하세요.</p>
            <div class="cta-buttons">
              <a href="javascript:void(0)" @click="goToAIConsult" class="main-btn ai-btn" style="font-size: 18px; padding: 15px 40px;">
                <i class="far fa-magic"></i> AI로 기획 시작하기
              </a>
              <a class="main-btn secondary-btn" href="#" @click.prevent="$root.$emit('open-contact-popup')" style="font-size: 16px; padding: 12px 30px;">
                <i class="far fa-comments"></i> 일반 상담하기
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goToAIConsult() {
      if (this.$route.name !== 'AIConsult') {
        this.$router.push({ name: 'AIConsult' });
      }
    }
  }
};
</script>

<style scoped>
.ai-studio-cta-area {
  background: #eef1f6;
  padding: 80px 0 100px;
}
.cta-title {
  font-size: 32px;
  margin-bottom: 15px;
  color: #0e1133;
  font-weight: 700;
}
.cta-desc {
  font-size: 18px;
  color: #505056;
  margin-bottom: 30px;
}
.cta-buttons {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}
.ai-btn {
  background: linear-gradient(135deg, #0a44b9 0%, #6366f1 100%) !important;
  box-shadow: 0 4px 15px rgba(10, 68, 185, 0.3);
}
.ai-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(10, 68, 185, 0.4);
}
.secondary-btn {
  background: #fff !important;
  color: #505056 !important;
  border: 2px solid #e8e8e8 !important;
}
.secondary-btn:hover {
  background: #f5f5f7 !important;
  border-color: #d5d5d5 !important;
}
</style>
